RivalIQ.apps.AccountSettings.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    function present(invoiceSettings) {
        return _.some(invoiceSettings, function (setting) {
            return setting && setting.length > 0;
        });
    }

    function formatAddressLine(addressLine) {
        if (addressLine && addressLine.length > 0) {
            return `${addressLine}<br />`;
        }
        return '';
    }

    function formatVatNumber(vatNumber) {
        if (vatNumber && vatNumber.length > 0) {
            return `${vatNumber}<br />`;
        }
        return '';
    }

    models.presentInvoiceSettings = function (invoiceSettings) {
        return _.tap({
            present: present(invoiceSettings)
        }, function (presented) {
            if (presented.present) {
                presented.companyName = formatAddressLine(invoiceSettings.companyName);
                presented.addressLine1 = formatAddressLine(invoiceSettings.addressLine1);
                presented.addressLine2 = formatAddressLine(invoiceSettings.addressLine2);
                presented.phoneNumber = formatAddressLine(invoiceSettings.phoneNumber);
                presented.vatNumber = formatVatNumber(invoiceSettings.vatNumber);
                presented.billingEmail = formatAddressLine(invoiceSettings.billingEmail);
            }
        });
    };
});
